<template>
    <div class="componentRoot">
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <RouterView />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>



<script>
export default {
    name: "productRoot",

    data() {
        return {

        }
    },

    computed: {
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
    },

    methods: {
    }
}

</script>